import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../entities/customer';
import { filter } from 'rxjs-compat/operator/filter';
import { Tracker } from '../entities/tracker';
import { TrackerService } from '../services/tracker.service';

@Pipe({
    name: 'filterCustomerTracker',
    pure: false
})
export class FilterCustomerTrackerPipe implements PipeTransform {


    constructor(public trackerService:TrackerService) {
    }

    transform(trackers: Tracker[], filterQuery: string): any {
        if (!trackers || !filterQuery) {
            return trackers;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return trackers.filter(tracker => {

            
            if (tracker.fullName.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) {
              
                return true;
            }
            else { 
                return false;
            };
            // .forEach(tracker => {


            //     tracker.fullName.toLowerCase().indexOf(filterQuery);
            // });
        });
        //         delivery.idCustom.indexOf(filterQuery) > -1 ||
        //         (delivery.vehicle && delivery.vehicle.name && delivery.vehicle.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
        //         (delivery.driver && delivery.driver.name && delivery.driver.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
        //         (delivery.deliveryGroup && delivery.deliveryGroup.name && delivery.deliveryGroup.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1));
        // //return items.filter(item => item.title.indexOf(filter.title) !== -1);
    }

    // transform(customers: Customer[], filterQuery: string): any {
    //     customers = this.trackerService.customers;
    //     if (!customers || !filterQuery) {
    //         return customers;
    //     }
    //     // filter items array, items which match and return true will be kept, false will be filtered out
    //     return customers.filter(customer => {

    //         var trackers:Tracker[] = customer.trackers.filter(tracker => {
    //             if (tracker.fullName.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) {
    //                 return true;
    //             } else {
    //                 return false;
    //             }
    //         })
    //         if (trackers.length > 0) {
    //             customer.trackers = trackers;
    //             return true;
    //         }
    //         else { 
    //             return false;
    //         };
    //         // .forEach(tracker => {


    //         //     tracker.fullName.toLowerCase().indexOf(filterQuery);
    //         // });
    //     });
    //     //         delivery.idCustom.indexOf(filterQuery) > -1 ||
    //     //         (delivery.vehicle && delivery.vehicle.name && delivery.vehicle.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
    //     //         (delivery.driver && delivery.driver.name && delivery.driver.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
    //     //         (delivery.deliveryGroup && delivery.deliveryGroup.name && delivery.deliveryGroup.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1));
    //     // //return items.filter(item => item.title.indexOf(filter.title) !== -1);
    // }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/pipes/filter-customer-tracker-directive.ts